import { Typography } from '@material-ui/core'
import React from 'react'
import Popup from '../Popup'
import Slide from '@material-ui/core/Slide'

const MAILTO =
  'mailto:support@gettingfocused.com?subject=Invite request&body=Please add me to the Getting Focused invite queue'

function SlideTransition(props) {
  return <Slide {...props} direction='up' />
}

export default ({ open, onConfirm = () => window.open(MAILTO) }) => {
  return (
    <Popup
      open={open}
      variant='info'
      message={
        <Typography>
          Currently, the Getting Focused App is invite only.
          <br />
          <br />
          Email us:{' '}
          <a href={MAILTO} target='_blank' rel='noopener noreferrer'>
            support@gettingfocused.com
          </a>
          <br />
          <br />
          or click this message to be added to the queue.
        </Typography>
      }
      onClick={onConfirm}
      preventCancel={false}
      transitionComponent={SlideTransition}
    />
  )
}
